import { Component, OnInit, NgZone, ElementRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import type { Hoarding } from '@app/_services/Instore';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService,IndividualConfig } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { InstoreService, AccountService } from '@app/_services'; 
// import { MapsAPILoader, MouseEvent as AGMMouseEvent, AgmMap } from '@agm/core'  
import * as moment from 'moment'; 
import { NgxSpinnerService } from "ngx-spinner"; 
import { ConfirmDialogService } from '@app/module/confirm-dialog/confirm-dialog/confirm-dialog.service';  

@Component({
  selector: 'app-addhoarding',
  templateUrl: './addhoarding.component.html',
  styleUrls: ['./addhoarding.component.css']
})
export class AddhoardingComponent implements OnInit {
  // @ViewChild('agmMap') agmMap : AgmMap

  private format = 'YYYY-MM-DD';

  form: UntypedFormGroup;
  submitted = false;
  isLoading = false;
  City: any = ['Option 1', 'Option 2', 'Option 3']
  hoardingName= "";
  RegionDataLists;
  ShowroomDataLists;
  AssetsDataLists;
  CreativeDataLists;
  VendorDataLists;

  FilterShowroomLists;
  selRegionValue: number;

  latitude: number;
  longitude: number;
  zoom:number;
  address: string;
  private geoCoder;

  minDate: any;

  user_role_id: number=0;
  user_region_id:number=0;
  user_Showroom_id:number=0;
  isDisabled:boolean=false;
  isAdmin:boolean=false;
  todayDate:Date = new Date();



  constructor(private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,private modalService: NgbModal,
    private instoreService: InstoreService,
    private accountService: AccountService,
    private router: Router,private toastr: ToastrService, private confirmDialogService: ConfirmDialogService ,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private spinner: NgxSpinnerService
    ) { }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      region_id: ['', Validators.required], //m
      showroom_id: ['', Validators.required], //m
      remarks: ['', Validators.required],
      address: ['', Validators.required],
      assettype: ['', Validators.required],
      creative: ['', Validators.required],
      vendor: ['', Validators.required],
      area: ['', Validators.required],
      width: ['', Validators.required],
      height: ['', Validators.required],
      install_date: ['', Validators.required],
      expiry_date: ['', Validators.required],
      // latitude: [''],
      // longitude: [''],
      name: ['', Validators.required],
      squarefeet: ['', Validators.required],
      cost: ['', Validators.required],
      image: [''] 
    });

    this.reloadRegionLists();
    this.reloadShowroomLists();
    this.reloadAssetsLists();
    this.reloadCreativeLists();
    this.reloadVendorLists();

    var userdata = localStorage.getItem('userInformation');
    var parsedUserData = JSON.parse(userdata);
    if(parsedUserData) {
      this.user_role_id = parsedUserData.role_id;
      if(this.user_role_id==1 || this.user_role_id==2){
        this.isAdmin = true;
      }
      this.user_region_id = parsedUserData.region_id;
      this.user_Showroom_id = parsedUserData.showroom_id;
    }


  }

  get f() { return this.form.controls; }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 10;
      });
    }
  }

  // markerDragEnd($event: AGMMouseEvent) {
  //   console.log($event);
  //   this.latitude = $event.coords.lat;
  //   this.longitude = $event.coords.lng;
  //   //this.getAddress(this.latitude, this.longitude);
  //   this.form.get("latitude").setValue(this.latitude); //Working
  //   this.form.get("longitude").setValue(this.longitude); //Working
  // }

  installChange(event) {
    if(event.value){
      //console.log("Date of Birth: " + moment(event.value).format(this.format) );
      //this.selInstallDate =  moment(event.value).format(this.format);
      //this.filterForInstore()
      this.minDate = event.value;
      this.resetExpiry();
    } else {
      //this.selInstallDate = "";
      //this.filterForInstore()
    }
  } 

  /*
  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      console.log(results);
      console.log(status);
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }
*/
onSubmit(modal_id: string) {
    this.submitted = true;

    if(!this.form.valid){
      console.log("Form is not valid"+this.form.errors);
      return;
    } 

    this.spinner.show();
    this.isLoading = true;
    this.hoardingName = this.f.name.value.trim();
    const formDataNew = new FormData();   
    formDataNew.append('area', this.f.area.value);
    formDataNew.append('name', this.f.name.value.trim());
    // formDataNew.append('lat', this.f.latitude.value);
    // formDataNew.append('lang', this.f.longitude.value);
    formDataNew.append('region_id', this.f.region_id.value);
    formDataNew.append('asset_type_id', this.f.assettype.value);
    formDataNew.append('creative_id', this.f.creative.value);

    formDataNew.append('square_feet', this.f.squarefeet.value);
    formDataNew.append('size_w', this.f.width.value);
    formDataNew.append('size_h', this.f.height.value);
    formDataNew.append('install_date', moment(this.f.install_date.value).format(this.format));
    formDataNew.append('expiry_date', moment(this.f.expiry_date.value).format(this.format));
    formDataNew.append('particulars', this.f.remarks.value);
    formDataNew.append('vendor_id', this.f.vendor.value,);
    formDataNew.append('cost', this.f.cost.value);
    formDataNew.append('showroom_id', this.f.showroom_id.value);
    formDataNew.append('image', this.form.get('image').value);
    formDataNew.append('address',this.f.address.value)
  

    this.confirmDialogService.confirmThis('Are you sure you want to save ?', () =>  {
          
      this.isLoading = true;
      this.instoreService.addHoarding(formDataNew)
      .pipe(first())
      .subscribe(
        (response) => {
          this.spinner.hide();
          if(response.state == "ERROR") {
            this.toastr.error("Hoarding name "+this.hoardingName+" already exists in this showroom", "Warning", {timeOut: 2500});
            } else if(response.state == "SUCCESS") {
              this.openModal(modal_id);
              this.onReset()
            }
          },
          (error) => {     
            this.spinner.hide();            
            this.toastr.error("Sorry, something went wrong Please try again", "Warning");              
          }
      );
      }, () => {
        
      }); 
  }

  onRegionChange(regionValue,isNew) {
    if (isNew) {
      let splitRegion = regionValue.split(" ");
      regionValue = splitRegion[1] ? splitRegion[1] : regionValue
    }
    this.selRegionValue =  parseInt(regionValue, 10);
    this.resetShowroom()
    this.FilterShowroomLists = this.ShowroomDataLists.filter(s => s.region_id === this.selRegionValue);
    if(!this.isAdmin){
      var selShowroomValue: number = this.user_Showroom_id;
      this.form.controls.showroom_id.setValue(this.FilterShowroomLists.filter(s => s.id === selShowroomValue)[0].id);
      this.isDisabled = true;

      this.form.get('region_id').disable();
      this.form.get('showroom_id').disable();
    }
}

resetExpiry() {
  this.form.patchValue({
    expiry_date: ''
  });
}

  onWidthChange(widthValue) {
    console.log("onWidthChange");
    this.updateSquareFeet()
  }

  onHeightChange(heightValue) {
    console.log("onHeightChange");
    this.updateSquareFeet()
  }

  updateSquareFeet() {
    if((this.f.width.value != "") && (this.f.height.value != "")) {
      let widthN = Number(this.f.width.value);
      let heihgtN = Number(this.f.height.value);
      console.log("updateSquareFeet "+widthN+" "+heihgtN);
      this.form.get("squarefeet").setValue(widthN*heihgtN);
    }
  }

  resetShowroom() {
    this.form.patchValue({
      showroom_id: ''
    });
  }

  onReset(){
    this.submitted = false;
    this.imageSrc = null;
    this.form.reset();
  }

  imageSrc: string;

  onFileChange(event) {

    const max_size = 100000;
    const allowed_types = ['image/png', 'image/jpeg'];


    const reader = new FileReader();
    const file:File = event.target.files[0];

    if (file.size > max_size) {
      alert("Image Size should not exceed more than 100 KB")
      return false;
  }
        
    if(event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.form.get('image').setValue(event.target.files[0]);
      };
   
    }
  }

  reloadRegionLists(){
    this.accountService.getRegionsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.RegionDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadShowroomLists(){
    this.accountService.getShowroomLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.ShowroomDataLists = response.result;
          if(!this.isAdmin){
            this.form.controls.region_id.setValue(this.user_region_id);
            this.onRegionChange(this.user_region_id,false);
            this.isDisabled= false;
        }
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  omit_special_char(event) {   
    var k;  
    k = event.charCode;  //         k = event.keyCode;  (Both can be used)
    return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57)); 
  }
  reloadAssetsLists(){
    this.accountService.getAssetsLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.AssetsDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }

  reloadCreativeLists(){
    this.accountService.getCreativeLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.CreativeDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }
  
   reloadVendorLists(){
    this.accountService.getVendorLists()
    .pipe(first())
      .subscribe(
      (response) => {
        this.isLoading = false;
        this.VendorDataLists = response.result;
      },
    (error) => {     
      this.isLoading = false;                               
    }
    );
  }


  closeResult :string
  openModal(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

}
